// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */

import { Box, Button, LinearProgress, Menu, MenuItem, Tooltip, Typography, } from '@mui/material';
import { DataGridPro, GridFilterModel } from '@mui/x-data-grid-pro'
import React, { useState, useEffect, } from 'react'
import { trTR } from '@mui/x-data-grid/locales';
import { DataGridProps, GridSlotsComponentsProps, GridToolbarColumnsButton, GridToolbarContainer, } from '@mui/x-data-grid';
import { Add, Clear, FileDownloadOutlined, Search } from '@mui/icons-material';
import { LicenseInfo } from '@mui/x-license';
import { mapReactFilterValueTypeToRequestFilterValueType, mapReactMUIToFilterOperationTypes } from '../../../utils/RequestFilterEnums';
import { styled } from '@mui/material/styles';
import './table.css';
import { downloadExcel, refactorData } from '../../utils/downloadExcel';
import { normalizeString } from '../../utils/normalizeString';
import { LinearProgressComp } from '../LinearProgressComp';
import { textColor } from '../../theme/palette';
import { primaryFont } from '../../theme/typography';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatColumns } from '../../utils/date-time-type';
import { useSnackbar } from 'notistack';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';

const key: string = process.env.REACT_APP_MUI_KEY || '';
LicenseInfo.setLicenseKey(key);

export type TableProps = DataGridProps & {
    components?: GridSlotsComponentsProps;
    onDownload?: () => void;
    exportFileName?: string;
    onSave?: () => any;
    isLoading?: boolean;
    isMasterDetailActive?: boolean;
    masterDetailContent?: ((params: GridRowParams<any>) => React.ReactNode) | undefined;
    masterDetailHeight?: ((params: GridRowParams<any>) => number | "auto") | undefined;
    isRowExpandable?: boolean;
    gotoAddCommisionPage?: () => void
};

const StyledGridOverlay = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    // "Table" komponentindeki gibi overlay sabit dursun
    width: '100%',
    minHeight: '100%',
    background: 'rgba(255, 255, 255, 0.65)',
    backdropFilter: 'blur(2px)',
    zIndex: 1,
    '& .ant-empty-img-1': {
        fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
    },
    '& .ant-empty-img-2': {
        fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
    },
    '& .ant-empty-img-3': {
        fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
    },
    '& .ant-empty-img-4': {
        fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
    },
    '& .ant-empty-img-5': {
        fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
        fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
    },
}));

function CustomNoRowsOverlay() {
    return (
        <StyledGridOverlay>
            <svg
                width="120"
                height="100"
                viewBox="0 0 184 152"
                aria-hidden
                focusable="false"
            >
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(24 31.67)">
                        <ellipse
                            className="ant-empty-img-5"
                            cx="67.797"
                            cy="106.89"
                            rx="67.797"
                            ry="12.668"
                        />
                        <path
                            className="ant-empty-img-1"
                            d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                        />
                        <path
                            className="ant-empty-img-2"
                            d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                        />
                        <path
                            className="ant-empty-img-3"
                            d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                        />
                    </g>
                    <path
                        className="ant-empty-img-3"
                        d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                    />
                    <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                        <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                        <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
                    </g>
                </g>
            </svg>
            <Box sx={{ mt: 1, fontSize: 14, color: '#888' }}>Kayıt Bulunamadı</Box>
        </StyledGridOverlay>
    );
}

const ListTable = ({
    columns,
    filterKey,
    openDialog,
    selectedRows,
    columnVisibilityConfigKey,
    hasActiveFilters,
    filterMode = 'server',
    extraToolbarButton,
    isMasterDetailActive = false,
    isLoading = false,
    rows,
    getRowId,
    addCommision,
    gotoAddCommisionPage,
    checkboxSelection,
    goToAddPage,
    createAddress,
    tableHeaderName,
    columnVisibilityModel,
    setColumnVisibilityModel,
    tabTableName,
    exportFileName,
    disabledDownload,
    noClear,
    ...props
}: TableProps) => {
    const { enqueueSnackbar } = useSnackbar();
    const [model, setModel] = useState({});
    const [filters, setFilters] = React.useState({});
    const [rowSelectionModel, setRowSelectionModel] = React.useState<GridRowSelectionModel>([]);
    const [filteredRows, setFilteredRows] = useState(rows);
    const [filterModel, setFilterModel] = useState({ items: [] }) // headerlardaki inputları temizler.
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });
    const [menuName, setMenuName] = useState('');
    const navigate = useNavigate();

    const findMenuNameByUrl = (url, items) => {
        for (const item of items) {
            if (item.url === url) {
                return item.name;
            }
            if (item.children) {
                const result = findMenuNameByUrl(url, item.children);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    };


    useEffect(() => {
        if (filterModel.items.length > 0) {
            let filteredData = [...rows];
            filterModel.items.forEach((filter) => {
                const { field, operator, value } = filter;
                filteredData = filteredData.filter((row) => {
                    const cellValue = row[field]; // hücredeki değer
                    if (operator === "is" || operator === "not" || operator === "isAnyOf") {
                        if (value === "") {
                            return true
                        }
                        switch (operator) {
                            case 'is':
                                return cellValue === parseFloat(value);
                            case 'not':
                                return cellValue !== parseFloat(value);
                            case 'isAnyOf':
                                return value.some((v: any) => cellValue === parseFloat(v));
                            default:
                                return value;
                        }
                    } else if (typeof cellValue === 'string') {
                        if (value === "") {
                            return true
                        }
                        switch (operator) {
                            case 'contains':
                                return normalizeString(cellValue).includes(normalizeString(value));
                            case 'doesNotContain':
                                return !normalizeString(cellValue).includes(normalizeString(value));
                            case 'equals':
                                return normalizeString(cellValue) === normalizeString(value);
                            case 'startsWith':
                                return normalizeString(cellValue).startsWith(normalizeString(value));
                            case 'endsWith':
                                return normalizeString(cellValue).endsWith(normalizeString(value));
                            case 'notEqual':
                                return normalizeString(cellValue) !== normalizeString(value);
                            case 'isEmpty':
                                return cellValue === '' || cellValue == null;
                            case 'isNotEmpty':
                                return cellValue !== '' && cellValue != null;
                            case 'isAnyOf':
                                if (operator === 'isAnyOf') {
                                    if (Array.isArray(value)) {
                                        // value'deki her öğe ile cellValue'yu eşitlik üzerinden kontrol et
                                        return value.some((v: string) => normalizeString(cellValue) === normalizeString(v));
                                    } else {
                                        return false; // Hatalı durumlarda false döndür
                                    }
                                }
                            default:
                                return true
                        }
                    }
                    else if (typeof cellValue === 'number') {
                        if (value === "") {
                            return true
                        }
                        switch (operator) {
                            case '=':
                                return cellValue === parseFloat(value);
                            case '!=':
                                return cellValue !== parseFloat(value);
                            case '>':
                                return cellValue > parseFloat(value);
                            case '<':
                                return cellValue < parseFloat(value);
                            case '<=':
                                return cellValue <= parseFloat(value);
                            case '>=':
                                return cellValue >= parseFloat(value);
                            case 'isEmpty':
                                return cellValue == null;
                            case 'isNotEmpty':
                                return cellValue != null;
                            case 'isAnyOf':
                                return value.some((v: any) => cellValue === parseFloat(v));  // Burada value'yu dizi olarak kabul ediyoruz
                            default:
                                return true
                        }
                    }

                    return true
                });
            });
            setFilteredRows(filteredData);
        } else {
            setFilteredRows(rows); // Eğer filtre yoksa tüm satırları göster
        }
    }, [filterModel, rows]);

    // Filtreler değiştiğinde çalışacak olan fonksiyon
    const handleFilterChange = (newFilterModel: GridFilterModel) => {
        setFilterModel(newFilterModel);
    };

    useEffect(() => {
        const storedFilters = localStorage.getItem(columnVisibilityConfigKey);
        const filtersObject = storedFilters
            ? JSON.parse(storedFilters)
            : {};
        setColumnVisibilityModel((currentModel) => ({
            ...currentModel,
            ...filtersObject,
        }));
    }, []);

    // MARK : generic functions
    const handleClear = (test) => {
        if (filterKey) {
            localStorage.removeItem(filterKey);
        }
        const newFilterModel: GridFilterModel = { items: [] };
        setFilters({});
        setFilterModel({ ...newFilterModel });
        let propsToSend = { clearFilter: true };
    };


    const handleColumnVisibilityChange = (newProps) => {
        if (Object.values(newProps).every((value) => value === true)) {
            setColumnVisibilityModel(newProps);
            localStorage.setItem(
                columnVisibilityConfigKey,
                JSON.stringify(newProps)
            );
        } else {
            setColumnVisibilityModel((currentModel) => {
                const updatedModel = {
                    ...currentModel,
                    ...newProps,
                };

                localStorage.setItem(
                    columnVisibilityConfigKey,
                    JSON.stringify(updatedModel)
                );

                return updatedModel;
            });
        }
    };
    const CustomToolbar = ({
        onDownload,
        onClear,
        selectedRows,
        openDialog,
        hasActiveFilters,
        extraButtons,
        gotoAddCommisionPage,
        goToAddPage,
        tableHeaderName,
        createAddress
    }: {
        onDownload: any;
        onClear: any;
        selectedRows: any;
        openDialog: any;
        hasActiveFilters: any;
        extraButtons?: any;
        gotoAddCommisionPage: any;
        goToAddPage: any;
        tableHeaderName: string;
        createAddress: any;
    }) => {
        return (
            <GridToolbarContainer
                sx={{ display: "flex", justifyContent: "space-between", padding: '0px !important', marginLeft: "10px" }}>
                {(tableHeaderName || tabTableName) ? (
                    <Typography sx={{ textAlign: 'center', margin: '10px 0', fontSize: '1rem', fontWeight: '600' }}>
                        {tableHeaderName || tabTableName}
                    </Typography>
                ) : (
                    <span />
                )}
                <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "end", margin: "10px" }}>
                    {goToAddPage && (
                        <Tooltip title={goToAddPage.title} arrow>
                            <Button sx={{ height: "24px", margin: '2px 3px', padding: '0 6px', minWidth: '30px', border: '1px solid #bdbdbd', gap: "2px" }} onClick={goToAddPage?.func}
                                className={hasActiveFilters ? "flashing" : ""}>
                                <Add sx={{ width: "16px !important", height: "16px !important" }} className={hasActiveFilters ? "flashing" : ""} />
                                <Typography sx={{ fontWeight: 'fontWeightBold', fontSize: "0.7rem !important " }}  >
                                    Ekle
                                </Typography>
                            </Button>
                        </Tooltip>
                    )}
                    {!noClear && <Tooltip title="Filtreleri Temizle" arrow>
                        <Button 
                            sx={{ 
                                height: "32px", 
                                margin: '0px 3px', 
                                padding: '0 12px', 
                                minWidth: '40px', 
                                border: '1px solid', 
                                borderColor: 'divider',
                                borderRadius: 2,
                                gap: "6px",
                                color: 'text.secondary',
                                backgroundColor: 'background.paper',
                                fontSize: '0.8rem',
                                fontWeight: 500,
                                textTransform: 'none',
                                '&:hover': {
                                    borderColor: 'primary.main',
                                    backgroundColor: 'primary.lighter',
                                    color: 'primary.main'
                                },
                                '&.flashing': {
                                    borderColor: 'warning.main',
                                    backgroundColor: 'warning.lighter',
                                    color: 'warning.dark'
                                }
                            }} 
                            onClick={() => onClear()} 
                            className={hasActiveFilters ? 'flashing' : ''}
                        >
                            <Clear sx={{ width: "16px !important", height: "16px !important" }} className={hasActiveFilters ? 'flashing' : ''} />
                            <Typography sx={{ fontSize: "0.8rem !important", fontWeight: 500 }}>
                                Temizle
                            </Typography>
                        </Button>
                    </Tooltip>
                    }
                    {!disabledDownload && onDownload && (
                        <PopupState variant="popover" popupId="listtable-download-menu">
                            {(popupState) => (
                                <>
                                    <Tooltip title="İndir" arrow>
                                        <Button
                                            {...bindTrigger(popupState)}
                                            sx={{
                                                height: "32px",
                                                margin: '0px 3px',
                                                padding: '0 12px',
                                                minWidth: '40px',
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                borderRadius: 2,
                                                gap: "6px",
                                                color: 'text.secondary',
                                                backgroundColor: 'background.paper',
                                                fontSize: '0.8rem',
                                                fontWeight: 500,
                                                textTransform: 'none',
                                                '&:hover': {
                                                    borderColor: 'primary.main',
                                                    backgroundColor: 'primary.lighter',
                                                    color: 'primary.main'
                                                }
                                            }}
                                        >
                                            <FileDownloadOutlined sx={{ width: "16px !important", height: "16px !important" }} />
                                            <Typography sx={{ fontSize: "0.8rem !important", fontWeight: 500 }}>
                                                İndir
                                            </Typography>
                                        </Button>
                                    </Tooltip>

                                    <Menu {...bindMenu(popupState)}>
                                        <MenuItem
                                            disabled={!rowSelectionModel || rowSelectionModel.length === 0}
                                            onClick={() => {
                                                popupState.close();
                                                onDownload?.('selected');
                                            }}
                                        >
                                            Seçili Satırları Excel'e Aktar
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                popupState.close();
                                                onDownload?.('all');
                                            }}
                                        >
                                            Tüm Verileri Excel'e Aktar
                                        </MenuItem>
                                    </Menu>
                                </>
                            )}
                        </PopupState>
                    )}
                    <GridToolbarColumnsButton
                        slotProps={{
                            button: {
                                sx: {
                                    height: '32px',
                                    margin: '0px 3px',
                                    padding: '0 12px',
                                    minWidth: '40px',
                                    color: 'text.secondary',
                                    fontWeight: 500,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 2,
                                    backgroundColor: 'background.paper',
                                    fontSize: '0.8rem',
                                    '&:hover': {
                                        borderColor: 'primary.main',
                                        backgroundColor: 'primary.lighter',
                                        color: 'primary.main',
                                    },
                                    '& svg': { width: 18, height: 18 },
                                },
                                className: hasActiveFilters ? 'flashing' : '',
                            },
                            tooltip: {
                                sx: {
                                    fontSize: '14px', // Optional: Set tooltip font size
                                },
                            },
                        }}
                    />
                    {extraButtons}

                </Box>
            </GridToolbarContainer>
        );
    }


    const customLocaleText = {
        ...trTR.components.MuiDataGrid.defaultProps.localeText,
        headerFilterOperatorContains: 'İçerir',
        headerFilterOperatorEquals: 'Eşittir',
        headerFilterOperatorStartsWith: 'Bununla Başlar',
        headerFilterOperatorEndsWith: 'Bununla Biter',
        headerFilterOperatorIs: 'Budur',
        headerFilterOperatorNot: 'Bu Değildir',
        headerFilterOperatorAfter: 'Sonra',
        headerFilterOperatorOnOrAfter: 'Bu Tarih veya Sonrası',
        headerFilterOperatorBefore: 'Önce',
        headerFilterOperatorOnOrBefore: 'Bu Tarih veya Öncesi',
        headerFilterOperatorIsEmpty: 'Boş',
        headerFilterOperatorIsNotEmpty: 'Boş Değil',
        headerFilterOperatorIsAnyOf: 'Şunlardan Herhangi Birine Sahip',
        headerFilterOperatorNotEquals: 'Eşit Değildir',
        headerFilterOperatorBetween: 'Arasında' // Eksik olan çeviriyi ekledik
    };

    const getEffectiveRowId = (row) => {
        try {
            return typeof getRowId === 'function' ? getRowId(row) : row?.id;
        } catch {
            return row?.id;
        }
    };

    const onExcelExport = (mode?: 'selected' | 'all') => {
        const sourceRows = (filteredRows ?? rows ?? []).filter(Boolean);

        const fileName = menuName || tableHeaderName || tabTableName || exportFileName || 'Dosya';
        const visibilityModelSafe = columnVisibilityModel ?? {};

        if (mode === 'selected') {
            if (!rowSelectionModel || rowSelectionModel.length === 0) {
                enqueueSnackbar('Seçili kayıt bulunamadı.', { variant: 'warning' });
                return;
            }
            const selectionSet = new Set(rowSelectionModel);
            const selectedData = sourceRows.filter((r) => selectionSet.has(getEffectiveRowId(r)));
            downloadExcel(refactorData(columns, selectedData, visibilityModelSafe), fileName, []);
            return;
        }

        // default/all: mevcut (filtrelenmiş) listeyi indir
        downloadExcel(refactorData(columns, sourceRows, visibilityModelSafe), fileName, []);
    }

    const formattedColumns = formatColumns(columns);

    const CustomLoadingOverlay = () => <LinearProgress sx={{ position: "absolute", top: "150px", zIndex: "100", width: "100% !important", height: "5px", background: "#05aa3c" }} />

    const handlePaginationModelChange = (newModel) => {
        setPaginationModel(newModel);
    };

    const location = useLocation()
    // Hücreye tıklanıldığında kopyalama işlemi
    const handleCellClick = (params) => {
        if (params.field==="status" && location.pathname === "/kyc-questions") {
            
        } else {
            const cellValue = params.value; // Tıklanan hücrenin değeri
            const cellLabel = params.field; // Hücrenin label'ı (sütun başlığı)

            // Panoya kopyalama
            navigator.clipboard.writeText(cellValue).catch(() => {
                enqueueSnackbar(`${cellLabel} hücresinin değeri kopyalanamadı.`, { variant: 'error' });
            });
        }

    };
    const handleSelectionModelChange = (newSelection: RowSelectionModel) => {
        if (filteredRows.length === 0)
            return
        const storedData = {
            filterModel,
            paginationModel,
            rowSelectionModel: newSelection,
            columnVisibilityModel
        };
        localStorage.setItem(filterKey, JSON.stringify(storedData));
        setRowSelectionModel(newSelection);
    };

    return (
        <DataGridPro
            {...props}
            sx={{
                ...(props?.sx ?? {}),
                // MUI overlay height inline style -> var(--DataGrid-overlayHeight, ...)
                // Full height için CSS variable'ı override ediyoruz
                '--DataGrid-overlayHeight': '100%',
                // Header filter input label'larını gizle (Table.tsx ile aynı davranış)
                '& .MuiInputLabel-shrink': { display: 'none' },
                '& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl': { display: 'none' },
           
            }}
            columns={formattedColumns}
            rows={filteredRows}
            filterModel={filterModel}
            disableDensitySelector={true}
            isRowExpandable={props.isRowExpandable}
            localeText={customLocaleText}
            checkboxSelection={checkboxSelection}
            loading={isLoading}
            rowHeight={43}
            slotProps={{
                loadingOverlay: {
                    variant: 'skeleton',
                    noRowsVariant: 'skeleton',
                },
            }}
            className='datagridpro'
            filterMode={props.filterMode ?? "server"}
            hideFooter={false}
            onFilterModelChange={handleFilterChange}
            localeText={trTR.components.MuiDataGrid.defaultProps.localeText}
            onRowSelectionModelChange={(newRowSelectionModel) => {
                handleSelectionModelChange(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            getRowId={getRowId}// burası props olarak gelmeli her bir tabloda id olmayabiliyor isim uyusmazlıgı ortaya cikiy
            pagination
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationModelChange}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            getDetailPanelContent={isMasterDetailActive ? props.getDetailPanelContent : null}
            slots={{
                loadingOverlay: CustomLoadingOverlay, // Burada bileşen adı olarak veriyoruz
                toolbar: () =>
                    CustomToolbar({
                        onDownload: onExcelExport,
                        createAddress: createAddress,
                        onClear: handleClear,
                        goToAddPage,
                        tableHeaderName: tableHeaderName,

                    }),
                columnMenuIcon: Search,
                noRowsOverlay: CustomNoRowsOverlay,
                noResultsOverlay: CustomNoRowsOverlay,
            }}
            autoHeight={props.autoHeight ?? true}
            onCellClick={handleCellClick}
        />

    )
}

export default ListTable